<template>
  <div class="full-screen">
    <!-- <map-new></map-new> -->
    <component :is="mapComponent"></component>
    <component :is="layerComponent"></component>
  </div>
</template>

<script>
//对于动态组件使用异步加载方式，优化性能
// const xx = import('....')
const mapNew = () => import("./newMap/mapNew"); //old规划面积, 产业园区
const cyldMap = () => import("./newMap/cyldMap"); //产业亮点
const zlMap = () => import("./newMap/zlMap"); //总览
const yzMap = () => import("./newMap/yzMap"); //种植基地
const ssztMap = () => import("./newMap/ssztMap"); //实施主体
const yqztzMap = () => import("./newMap/yqztzMap"); //园区总投资 ，项目建设
const xmflMap = () => import("./newMap/xmflMap"); //项目分类
const xmzjdMap = () => import("./newMap/xmzjdMap"); //项目总进度
const lndnMap = () => import("./newMap/lndnMap"); //联农带农
const zhwMap = () => import("./newMap/zhwMap"); //智慧物联
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      layer: ""
    };
  },
  components: {
    zlMap,
    cyldMap,
    mapNew,
    yzMap,
    ssztMap,
    yqztzMap,
    xmzjdMap,
    lndnMap,
    xmflMap,
    zhwMap
  },
  computed: {
    ...mapGetters(["mapComponent", "seleNav", "layerComponent"])
  },
  watch: {
    seleNav(val) {
      this.resetMap(val);
      this.$store.dispatch("map/setLayerComponent", null);
    },
    mapComponent(v) {
      console.log("map ==> ", v);
    }
  },
  mounted() {
    this.resetMap(this.seleNav);
    // this.$store.dispatch("map/setMapComponent", "mapNew");
  },
  methods: {
    resetMap(val) {
      if (val == 0) {
        this.$store.dispatch("map/setMapComponent", "zlMap");
      } else if (val === 1) {
        this.$store.dispatch("map/setMapComponent", "cyldMap");
      } else if (val === 2) {
        this.$store.dispatch("map/setMapComponent", "yzMap");
      } else if (val == 3) {
        this.$store.dispatch("map/setMapComponent", "mapNew");
      } else if (val == 4) {
        this.$store.dispatch("map/setMapComponent", "ssztMap");
      } else if (val === 5) {
        this.$store.dispatch("map/setMapComponent", "zhwMap");
      } else if (val == 7) {
        this.$store.dispatch("map/setMapComponent", "yqztzMap");
      } else if (val === 8) {
        this.$store.dispatch("map/setMapComponent", "lndnMap");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.full-screen
  position fixed
  top 0
  bottom 0
  left 0
  right 0
</style>
